module.exports = __webpack_public_path__ + "img/kayak_1413_2.b2137861.jpg";